import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';

/**
 * A collapsible section, built on `mat-expansion-panel`.
 *
 * Material rather than hand-built for the `aria-expanded` / `aria-controls`
 * wiring and the height animation, both of which are easy to get subtly wrong
 * by hand.
 *
 * Body content is projected, so the caller owns what is inside. `expanded` is
 * two-way, which lets a parent keep several panels in an accordion without
 * this component knowing anything about its siblings.
 */
@Component({
  selector: 'bz-expansion-panel',
  imports: [MatExpansionModule],
  templateUrl: './bz-expansion-panel.html',
  styleUrl: './bz-expansion-panel.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BzExpansionPanel {
  readonly heading = input('');
  /** Secondary text on the header row, to the right of the heading. */
  readonly description = input('');
  readonly disabled = input(false);
  readonly expanded = model(false);
}
